export const products = [
  {
    id: '1',
    title: 'Ethereal Tides',
    artist: 'Elena Rostova',
    price: 185,
    image: 'https://images.unsplash.com/photo-1541701494587-cb58502866ab?auto=format&fit=crop&q=80&w=1000',
    mood: 'Calm',
    room: 'Bedroom',
    notes: 'A study in deep blues and subtle textures, capturing the fleeting moment between high and low tide. The ultramarine dominating this piece was custom-mixed in the studio.',
    dimensions: '24" x 36"',
    medium: 'Archival pigment print on 310gsm cotton rag',
    series: 'Coastal Horizons'
  },
  {
    id: '2',
    title: 'Urban Geometry',
    artist: 'Marcus Chen',
    price: 145,
    image: 'https://images.unsplash.com/photo-1605721911519-3dfeb3be25e7?auto=format&fit=crop&q=80&w=1000',
    mood: 'Focused',
    room: 'Office',
    notes: 'Stripping away the chaos of the city to reveal its underlying structure. This minimalist piece plays with negative space and sharp angles.',
    dimensions: '18" x 24"',
    medium: 'Silver gelatin fine art print',
    series: 'Concrete Soul'
  },
  {
    id: '3',
    title: 'Dolomite Ridge',
    artist: 'Sarah Jenkins',
    price: 210,
    image: 'https://images.unsplash.com/photo-1469474968028-56623f02e42e?auto=format&fit=crop&q=80&w=1000',
    mood: 'Inspiring',
    room: 'Living Room',
    notes: 'Captured during the golden hour in the Italian Alps. The sheer scale of the landscape is meant to provide a sense of grounding and perspective.',
    dimensions: '30" x 40"',
    medium: 'C-type print on museum matte paper',
    series: 'Altitude'
  },
  {
    id: '4',
    title: 'Botanical Study IV',
    artist: 'Amira Tariq',
    price: 120,
    image: 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&q=80&w=1000',
    mood: 'Vibrant',
    room: 'Dining',
    notes: 'Part of a series exploring the microscopic details of everyday flora. The contrast between the organic subject and the stark background highlights nature\'s design.',
    dimensions: '16" x 20"',
    medium: 'Giclée fine art print',
    series: 'Micro Flora'
  },
  {
    id: '5',
    title: 'Silent Morning',
    artist: 'David O\'Connor',
    price: 165,
    image: 'https://images.unsplash.com/photo-1479839672679-a46483c0e7c8?auto=format&fit=crop&q=80&w=1000',
    mood: 'Calm',
    room: 'Bedroom',
    notes: 'Fog rolling over the hills of Northern California. The muted palette relies heavily on subtle shifts in charcoal and grey tones.',
    dimensions: '20" x 30"',
    medium: 'Archival pigment print',
    series: 'Atmosphere'
  },
  {
    id: '6',
    title: 'Abstract Composition 09',
    artist: 'Studio K',
    price: 195,
    image: 'https://images.unsplash.com/photo-1547826039-bfc35e0f1ea8?auto=format&fit=crop&q=80&w=1000',
    mood: 'Energetic',
    room: 'Living Room',
    notes: 'An exploration of color theory and kinetic movement. This piece was created using a mixture of digital and analog techniques.',
    dimensions: '24" x 24"',
    medium: 'Mixed media fine art print',
    series: 'Motion'
  }
];

export const reviews = [
  { id: 1, author: 'M. Thompson', rating: 5, date: 'Oct 12, 2023', text: 'Stunning print quality. The ultramarine frame complements my living room perfectly.' },
  { id: 2, author: 'J. Davis', rating: 5, date: 'Sep 28, 2023', text: 'Arrived impeccably packaged. The artist notes added a lovely personal touch.' },
  { id: 3, author: 'L. Chen', rating: 4, date: 'Aug 15, 2023', text: 'Beautiful piece, though the shipping took a day longer than expected.' }
];

export const faqData = [
  { question: 'What type of paper do you use?', answer: 'We use 310gsm museum-quality Hahnemühle cotton rag paper for all our fine art prints, ensuring longevity and exceptional color reproduction.' },
  { question: 'Are the frames solid wood?', answer: 'Yes, all our frames are custom-milled from sustainable solid ash or oak, depending on the finish you select.' },
  { question: 'Do you ship internationally?', answer: 'Currently, we ship within North America and Europe. We are working on expanding our global shipping network.' }
];